import { withNamespaces } from "react-i18next";
import { memo, useEffect, useState } from "react";
import { Nav, NavItem, NavLink } from "reactstrap";
import { useHistory, useLocation } from "react-router-dom";

const Tabs = memo(({ t, totalCount, deletedCount }) => {
    const [activeTab, setActiveTab] = useState('');
    const history = useHistory();
    const location = useLocation();

    const isActiveTab = (currentTab, tab) => currentTab === tab;

    const tabsLinks = [
        {
            key: "assets-list",
            title: `${t("All Other Assets")} ${totalCount ? "(" + totalCount + ")" : ""}`,
        },
        {
            key: "deletion-protocol",
            title: `${t("Deletion Protocol")} ${deletedCount ? "(" + deletedCount + ")" : ""
                }`,
        },
    ];

    useEffect(() => {
        const tabKey = (new URLSearchParams(location.search)).get('tab');
        const tab = (tabsLinks.find((tab) => tab.key === tabKey))?.key;

        if(!tab) {
            history.push(`?tab=assets-list`);
        }
        else{
            setActiveTab(tab);
        }
    }, [
        location.search
    ]);

    return (
        <div
            style={{
                backgroundColor: "#D1D2D6",
            }}
        >
            <Nav tabs className="custom-style-1">
                {tabsLinks.map((link) => {
                    return (
                        <NavItem
                            className={isActiveTab(activeTab, link.key) ? "active" : ""}
                            key={link.key}
                        >
                            <NavLink
                                className={isActiveTab(activeTab, link.key) ? "active" : ""}
                                onClick={() => history.push(`?tab=${link.key}`)}
                            >
                                {t(link.title)}
                            </NavLink>
                        </NavItem>
                    );
                })}
            </Nav>
        </div>
    );
});

export default withNamespaces()(
    Tabs
);
